import { render, staticRenderFns } from "./ViewSpecialRateSubscriberInfo.vue?vue&type=template&id=88d74e20&"
import script from "./ViewSpecialRateSubscriberInfo.vue?vue&type=script&lang=js&"
export * from "./ViewSpecialRateSubscriberInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports